<script setup>
//可追溯性仪表板-数字护照
import {
    onMounted, ref,
    nextTick,
    provide,
    watch
} from 'vue';
import myCardCom from '../components/traceability/myCard.vue';
import headerCom from '../components/common/header.vue';
import { drawRadar } from "@/utils/chart.js"
import { getDashboardIndex_radar_map } from "@/service/apiList/dashboard"
import { sankey_v3 } from "@/service"
import i18n from "@/i18n"
import { useRoute, useRouter } from 'vue-router';
import nextIcon from "@/assets/images/products/disabled-next.png"
import prevIcon from "@/assets/images/products/disabled-prev.png"
import { sankey2Chart } from "@/utils/chart.js"
import { showMessage } from "@/utils/hooks/message"
import { getNewline, formateValue } from "@/utils/common"
import myDailog from '../components/common/myDailog.vue';
import { getLangValue } from "@/utils/common"; //获取后端语言

// import dataJson from "@/utils/test"
const colors = ['#5470c6', '#91cc75', '#3ba272', '#ee6666', '#73c0de']
const cardRef = ref(null) // card dom
const groupList = ref([]) // 存储子组数据
const activeGroup = ref('')
const showBtn = ref(false) // 显示左右按钮
const btnPostion = ref('left') // 按钮滚动的位置
const route = useRoute() // 路由
const router = useRouter() // 路由
const chartData = ref({}) // 图表数据
const charts_map = ref(null) //追溯图部分
const detailInfo = ref({}) //详情信息
const currentTab = ref(0) // 当前tab
const disabledLoading = ref(false) //如果在加载就不需要
const visible = ref(false) // 弹框图表
const optionsList = ref([]) //存储所有表信息
const title = ref('') //大图表标题
const sankey_v3_data = ref({}) // 存储产地-组成结构数据
const subCategory = ref('') // 选中的子组  质量 pef ...
let chartPlace = null;
provide('detailInfo', detailInfo)
const loadingSankey = ref(false) // 桑基图加载效果
const loadingRadar = ref(false) // 雷达图加载效果
provide('loadingRadar', loadingRadar)
provide('loadingSankey', loadingSankey)
const serChartSeriesValue = (name) => {
    // 设置图标series 数据
    let seriesObj = [
        {
            type: 'radar',
            tooltip: {
                trigger: 'item',
            },
            radarIndex: 0,
            // areaStyle: {},
            data: []
        },
    ]
    let avgValueList = [] // 存储均值数据
    let legendData = []
    // for (const item in chartData.value) {
    // if (!chartData.value.show) continue;
    const list = chartData.value.data
    let arr = list.filter(item => item.name == name)

    if (arr.length) {
        let children = arr[0].children
        children.sort((a, b) => {
            // 将 name 为 "综合" 的对象排到最前面
            if (a.name === "综合" && b.name !== "综合") return -1;
            if (a.name !== "综合" && b.name === "综合") return 1;
            return 0; // 其他元素保持原始顺序
        });
        let children_value_lsit = children.map(item1 => item1.value)
        seriesObj[0].data.push({
            name: chartData.value.name,
            value: children_value_lsit,
            // color: chartData.value[item].color,
            // 线条颜色
            lineStyle: {
                color: chartData.value.color
            },
            // 图形颜色  影响legend
            itemStyle: {
                color: chartData.value.color
            },
        })
        legendData.push(chartData.value.name);
        // console.log(avgValueList.length);
        if (avgValueList.length == 0) {
            avgValueList = children.map(item1 => item1.avg_value)
            seriesObj[0].data.push({
                name: getLangValue('dashboard.avg_value'),
                value: avgValueList,
                lineStyle: {
                    color: '#7F7F7F',
                },
                itemStyle: {
                    color: '#7F7F7F'
                },
            })
            legendData.push(getLangValue('dashboard.avg_value'));
        }
    }
    // }
    // 排序将均值排在最后面
    legendData.sort((a, b) => {
        if (a === getLangValue('dashboard.avg_value') && b !== getLangValue('dashboard.avg_value')) return 1;
        if (a !== getLangValue('dashboard.avg_value') && b === getLangValue('dashboard.avg_value')) return -1;
        return 0; // 其他元素保持原始顺序
    });
    return { seriesObj, legendData }
}

const showCharts = () => {
    // 展示图表
    optionsList.value = []
    for (const item in groupList.value) {
        let { seriesObj: data, legendData: legendData } = serChartSeriesValue(groupList.value[item].name);
        //设置三个图表
        const { children } = groupList.value[item]
        let indicatorList = children.map(item => {
            return {
                name: i18n.global.locale == 'en' ? getNewline(item.name_en, 10) : getNewline(item.name, 10),
                name1: i18n.global.locale == 'en' ? item.name_en : item.name,
                max: 1,
            }
        })
        let option = {
            color: colors,
            tooltip: {
                trigger: 'axis',
                confine: true,
                formatter: function (params) {
                    let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
                    for (const item in params.value) {
                        str += `

                        <div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${indicatorList[item].name1}
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item] == null ? '-' : formateValue(params.value[item])}</div>
                    </div>`
                    }
                    return str
                }
            },
            legend: {
                data: legendData,
                bottom: 0,
            },
            radar: {
                indicator: indicatorList,
                radius: indicatorList.length == 2 ? 60 : 70,
                center: indicatorList.length == 2 ? ['50%', '45%'] : indicatorList.length == 3 ? ['50%', '55%'] : ['50%', '50%'],
                // 设置角标颜色和样式
                axisName: {
                    color: '#000', // 设置角标颜色
                    fontSize: 13, // 字体大小
                },
                splitLine: { //里面四个圈线条样式
                    lineStyle: {
                        color: [
                            'rgba(169,169,169, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                        ],//分别对应四个第一个对应最里面的圈
                        width: 2,
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: "rgba(169,169,169, 1)",
                        width: 2, // 轴线宽度
                    }
                },
                axisLabel: {
                    show: true,
                    formatter: function (value, index) {
                        // 只在最后一个角显示最大值
                        if (index === 5) {
                            return value;
                        } else {
                            return '';
                        }
                    },
                    margin: 10,
                }
            },
            series: data,
        };
        optionsList.value.push({ option, indicatorList });//把图表数据存储起来
        // visible.value = true
        nextTick(() => {
            let dom = document.getElementById(`groupChart_${item}`)
            drawRadar(dom, option)
        })
    }
}

const showBigChart = (key) => {
    // 展示大图
    visible.value = true
    title.value = groupList.value[key].name ? `${getLangValue('dashboard.traceability.performance_of_pef_Indicator_Grouping')}-${i18n.global.locale == 'en' ? groupList.value[key].name_en : groupList.value[key].name}` : getLangValue('dashboard.traceability.performance_of_pef_Indicator_Grouping');
    nextTick(() => {
        let dom = document.getElementById(`myChartsRef`)
        dom.setAttribute('_echarts_instance_', '')
        let { option, indicatorList } = optionsList.value[key];
        // 修改部分信息
        option.radar.radius = 150;
        option.radar.center = ['50%', '50%'];
        // 修改名称 不需要换行了
        option.radar.indicator = indicatorList.map(item => {
            return {
                name: item.name1,
                max: item.max
            }
        });
        drawRadar(dom, option)
    })
}

const setGroupName = (data) => {
    // 设置数据
    if (data.length == 0) return
    groupList.value = data.filter(item => item.name != '综合' && item.name.indexOf('总体') == -1)
    showBtn.value = groupList.value.length >= 4 ? true : false; // 显示左右切换按钮
}

const switchGroup = (key, item) => {
    //切换组名 
    activeGroup.value = key
    // 切换展示数据
    // subCategory.value = item.category_id;  // 质量试一下
    // cardRef.value.showPlaceChart = false; // 取消选中
    // 修改为跳转到新的数字护照页面
    let query = {
        hscode: detailInfo.value.production_line?.database_template?.hscode?.id,
        keyword: detailInfo.value.pid, // pid作为索引
        product_template_name: [
            i18n.global.locale == 'en' ? detailInfo.value.production_line?.database_template?.name_en : detailInfo.value.production_line?.database_template?.name,
            detailInfo.value.production_line?.database_template?.destination_market?.id
        ],
    }
    // 根据不同category_id跳转到对应的数字护照页面
    let path = '';
    switch (item.category_id) {
        case 3:
            path = '/dashboard-quality-digital-passport';
            break;
        case 5:
            path = '/dashboard-environment-digital-passport';
            break;
        case 6:
            path = '/dashboard-esg-digital-passport';
            break;
        case 4:
            path = '/dashboard-circularity-digital-passport';
            break;
        case 2:
            path = '/dashboard-comfort-digital-passport';
            break;
        case 1:
            path = '/dashboard-traceability-digital-passport';
            break;
        default:
            path = '/dashboard-quality-digital-passport';
            break;
    }
    let url = router.resolve({ path: path, query: query }).href
    window.open(url, '_blank')
}

const getRadaData = async () => {
    // 获取雷达图数据
    let params = {
        category_id: 1, // 5 可追溯性
        id: route.query.id,
    }
    loadingRadar.value = true;
    const resp = await getDashboardIndex_radar_map(params);
    loadingRadar.value = false;
    // card部分只显示当前选中数据的特殊指标和雷达图
    // 保存数据
    let productsname_key_info = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_product_name')
    let product_name = '';
    if (productsname_key_info.length > 0) {
        product_name = productsname_key_info[0].value
    }
    chartData.value = {
        name: `${product_name}`,
        data: resp.payload.radar_map,
        indicator_standard_list: resp.payload.specific_index_standard_list,
        show: true,
        color: colors[0],
    }

    // 获取组名
    setGroupName(resp.payload.radar_map)
    // 重新绘制图表
    showCharts()
    // 特殊指标
    cardRef.value.indicator_standard_list = chartData.value.indicator_standard_list
    //// 雷达图数据
    cardRef.value.drawRadarChart(chartData.value.data)
}


const isScrolledToRight = (element) => {
    //是否到达右边
    btnPostion.value = element.scrollLeft + element.clientWidth >= element.scrollWidth ? 'right' : ''
    return element.scrollLeft + element.clientWidth >= element.scrollWidth;
};

const isScrolledToLeft = (element) => {
    //是否到达左边
    btnPostion.value = element.scrollLeft === 0 ? 'left' : ''
    return element.scrollLeft === 0;
};

const prev = () => {
    //上一个
    //验证是否到达左边
    const element = document.getElementById('chart-group')
    if (isScrolledToLeft(element)) return;
    const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示上一个chart 因为我设置的宽度30%
    element.scrollTo({
        left: element.scrollLeft - scrollAmount,
        behavior: "smooth"
    });
}

const next = () => {
    //下一个
    //验证是否到达右边
    const element = document.getElementById('chart-group')
    if (isScrolledToRight(element)) return;
    const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示下一个chart 因为我设置的宽度30%
    element.scrollTo({
        left: element.scrollLeft + scrollAmount,
        behavior: "smooth"
    });
}

const showSankeyChart = async (type = 0,) => {
    //展示桑吉图表信息
    disabledLoading.value = true;
    let params = {
        table_name: detailInfo.value.organization.table_name,
        database_id: detailInfo.value.id,
        category_id: 1,
        type: type,
    }
    if (subCategory.value != '') {
        params.sub_category_id = subCategory.value
    }
    disabledLoading.value = false;
    loadingSankey.value = true;
    const reps = await sankey_v3(params)
    loadingSankey.value = false;
    if (reps.code == 1) {
        showMessage('danger', reps.message)
        return
    }
    if (reps.payload.nodes.length && reps.payload.links.length) {
        let obj = JSON.parse(JSON.stringify(reps.payload))
        const { nodes: nodes1, links: links1 } = obj;
        sankey_v3_data.value = {
            nodes: nodes1,
            links: links1
        }
        nextTick(() => {
            makeCharts(reps.payload, type)
        })
    } else {
        showMessage('info', getLangValue('base.no_data'))
    }
}

const makeCharts = (data, type, dom1 = 'charts_map') => {
    // 开始画桑基图
    // let attributes = {}
    // // 属性信息
    // for (const item in data.nodes) {
    //     attributes[data.nodes[item].name] = data.databases[item].pid
    // }
    let options = {
        chartDom: dom1 == 'charts_map' ? charts_map.value : document.getElementById(dom1),
        data: data,
        nodeDataList: data.nodes
    };
    if (chartPlace) {
        let dom = document.getElementById(dom1)
        dom.setAttribute('_echarts_instance_', '')
    }
    chartPlace = type == 0 ? sankey2Chart(options, true, 'normal', 'place',) : sankey2Chart(options, true, 'normal', 'value',);
}

const showPlaceChart = () => {
    // 重置  重新请求
    subCategory.value = '';
    activeGroup.value = ''
    showBigSnaky();
}

const showBigSnaky = () => {
    //放大桑基图
    visible.value = true
    title.value = currentTab.value == 0 ? getLangValue('dashboard.traceability.origin_traceability_map') : getLangValue('dashboard.traceability.composition_traceability_diagram')
    nextTick(() => {
        let dom = document.getElementById(`myChartsRef`)
        dom.setAttribute('_echarts_instance_', '')
        makeCharts(sankey_v3_data.value, currentTab.value, 'myChartsRef')
    })

}

onMounted(async () => {
    getRadaData()
})

watch(detailInfo, () => {
    //数据加载完了才显示桑基图
    showSankeyChart()
})

watch(currentTab, (val) => {
    if (sankey_v3_data.value.nodes) {
        console.log(sankey_v3_data.value.links);
        makeCharts(sankey_v3_data.value, val)
    } else {
        showSankeyChart(val);
    }
})

watch(subCategory, () => {
    // 子组改变需要调新的接口
    showSankeyChart(currentTab.value)
})


</script>
<template>
    <!-- 可追溯性dashboard -->
    <div class="environment-passport1 my-scroll-bar">
        <headerCom :title="getLangValue('dashboard.traceability.title')" />
        <div class="main d-flex">
            <div class="left-aside  my-scroll-bar">
                <myCardCom :category="1" ref="cardRef" :placeholder="getLangValue('dashboard.input1')"
                    :title="getLangValue('dashboard.traceability.titleText')"
                    :title1="getLangValue('dashboard.traceability.titleText5_new')"
                    :title2="getLangValue('dashboard.traceability.special_environmental_indicators')"
                    :sankey_v3_data="sankey_v3_data" @showPlaceChart="showPlaceChart" />
            </div>

            <div class="center mx-2 d-flex flex-column my-scroll-bar">
                <div class="card px-3 py-2">
                    <div class="my-card-header">{{
                        getLangValue('dashboard.traceability.performance_of_pef_Indicator_Grouping') }}
                    </div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border-top: 1px solid #E9EBEC;" />
                    <!-- 图表数据 -->
                    <div class="my-group-charts d-flex justify-content-between align-items-center"
                        style="margin-top: -6px; height: 300px;" v-loading="loadingRadar">
                        <div style="width: 14px; display: inline-block;" v-if="showBtn && btnPostion != 'left'"
                            class="me-2">
                            <img :src="prevIcon" style="width: 16px; height: auto;" @click="prev"
                                class="cursor-pointer">
                        </div>
                        <div id="chart-group"
                            style="display: block;overflow: hidden;box-sizing: border-box; margin: 0 auto; padding: 0; white-space: nowrap; flex: 1;"
                            v-if="groupList.length">
                            <div style="display: inline-block; width: 33%;height: 300px;" class="mx-2 chart-item"
                                v-for="(item, key) in groupList" :key="key">
                                <div :id="`groupChart_${key}`" style="width: 100%; height: 280px;"
                                    @dblclick="showBigChart(key)"></div>
                                <div style="text-align: center;">
                                    <span class="cursor-pointer" :class="activeGroup === key ? 'activeGroup' : ''"
                                        @click="switchGroup(key, item)">{{
                                            i18n.global.locale == 'en' ? item.name_en : item.name
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div style="width:14px;display: inline-block; text-align: right;"
                            v-if="showBtn && btnPostion != 'right'" class="ms-2">
                            <img :src="nextIcon" style="width: 16px; height: auto;" @click="next"
                                class="cursor-pointer">
                        </div>
                    </div>
                </div>
                <div class="card px-3 py-2" style="flex:1;border-radius: 0.55rem;height: calc(100% - 390px - 1rem);"
                    id="tableDom">
                    <div class="my-card-header">
                        <div class="d-flex justify-content-between align-items-center">
                            {{ currentTab == 0 ? getLangValue('dashboard.traceability.origin_traceability_map') :
                                getLangValue('dashboard.traceability.composition_traceability_diagram')}}
                            <el-radio-group v-model="currentTab" size="" :disabled="disabledLoading">
                                <el-radio-button :label="getLangValue('dashboard.traceability.origin_traceability')"
                                    value="0" />
                                <el-radio-button :label="getLangValue('attribute.composition')" value="1" />
                            </el-radio-group>
                        </div>
                    </div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border-top: 1px solid #E9EBEC;" />
                    <div class="my-card-content my-scroll-bar"
                        style="overflow-y: auto;height: calc(100% - 40px - 1rem);">
                        <div style="font-weight: bold;">{{ currentTab == 0 ?
                            getLangValue('dashboard.traceability.product_name_origin') :
                            getLangValue('dashboard.traceability.product_name_composition_ratio') }}</div>
                        <div ref="charts_map" id="charts_map" class="w-100" style="height: 100%;"
                            @dblclick="showBigSnaky"></div>
                    </div>
                </div>
            </div>
            <!-- <div class="right-aside">
                <div class="card px-3 py-2" style="height: calc(100% - 1.3rem ) ;">
                    <myRankCard :hscodeList="hscodeList" :hscodeTopList="hscodeTopList"
                        :placeholder="getLangValue('dashboard.input1')" />
                </div>
            </div> -->
        </div>
    </div>
    <myDailog v-if="visible" v-model:visible="visible" :title="title" :width="800">
        <div style="font-weight: bold;">{{ currentTab == 0 ? getLangValue('dashboard.traceability.product_name_origin') :
            getLangValue('dashboard.traceability.product_name_composition_ratio') }}</div>
        <div style="width: 100%; height: 500px;" id="myChartsRef"></div>
    </myDailog>
</template>
<style scoped lang="scss">
.environment-passport {
    background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    .header {
        height: 60px;

        .title {
            font-size: 24px;
            font-weight: 700;
            color: white;
        }

        .home {
            font-size: 20px;
            font-weight: 700;
            color: white;
        }
    }

    .main {
        height: calc(100vh - 60px); //way-1

        .left-aside {
            display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            width: 500px;
            // overflow-y: auto;
            margin-bottom: 1.3rem;
            height: 100%;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1
            max-width: calc(100% - 500px);

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: white;
                        }

                        .form-control {
                            background-color: #4a5056;
                            color: white;
                        }
                    }
                }
            }
        }

        .right-aside {
            width: 480px;

            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }
    }
}

.environment-passport1 {
    // background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    // .header {
    //     height: 60px;

    //     .title {
    //         font-size: 24px;
    //         font-weight: 700;
    //         color: white;
    //     }

    //     .home {
    //         font-size: 20px;
    //         font-weight: 700;
    //         color: white;
    //     }
    // }

    .main {
        height: calc(100vh - 60px); //way-1

        .left-aside {
            display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            width: 500px;
            // overflow-y: auto;
            margin-bottom: 1.3rem;
            height: 100%;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1
            max-width: calc(100% - 500px);

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                // background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: #212529;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        // :deep(.el-input__wrapper) {
                        //     // background-color: #4a5056;
                        // }

                        :deep(.el-input__inner) {
                            color: #212529;
                        }

                        .form-control {
                            // background-color: #4a5056;
                            color: #212529;
                        }
                    }
                }
            }

            .activeGroup {
                color: #0AB39C;
                text-decoration: underline;
            }

            :deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
                background-color: #0AB39C;
                border-color: #0AB39C;
            }
        }


        .right-aside {
            width: 480px;

            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }

        #chart-group .chart-item {
            border-right: 1px solid #D9D9D980;

            &:last-child {
                border-right: none;
            }
        }
    }
}
</style>
